import { render } from "./ContactBanner.vue?vue&type=template&id=dbe321e8&scoped=true"
const script = {}

import "./ContactBanner.vue?vue&type=style&index=0&id=dbe321e8&lang=scss&scoped=true"

import exportComponent from "D:\\Projects For Fun\\PortfolioWebsite\\portfolio\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dbe321e8"]])

export default __exports__